import { localiseCurrency } from "./translations-utils.js";

export function getSpendLimit(maxTotalOrderSpendConfig) {
  if (
    window.spendLimitOverride &&
    typeof window.spendLimitOverride === "number"
  ) {
    return window.spendLimitOverride;
  }

  const limits = maxTotalOrderSpendConfig || {};
  const limitsKeys = Object.keys(limits);

  if (!limitsKeys.length === 0) {
    console.warn(
      "Max total order spend config not found. Falling back to hardcoded default."
    );
    return 7400; // lowest limit value for any supported currency
  }

  if (!window.channelCurrency || !limitsKeys.includes(window.channelCurrency)) {
    console.warn(
      "Channel currency or max total order spend config entry for channel currency not found. The lowest configured limit value will be used instead."
    );
    return parseInt(
      Object.values(limits).sort(
        (a, b) => parseInt(a, 10) - parseInt(b, 10)
      )[0], // lowest limit value
      10
    );
  }

  return parseInt(maxTotalOrderSpendConfig[window.channelCurrency], 10);
}

export function isSpendLimitExceeded(maxTotalOrderSpendConfig, cartData) {
  const totalSpendLimit = getSpendLimit(maxTotalOrderSpendConfig);
  const currentCartTotal = cartData.cartAmount || 0;

  return currentCartTotal > totalSpendLimit;
}

export function showSpendLimitExceededModal(
  maxTotalOrderSpendConfig,
  translationsJSON,
  showAlertModal
) {
  const maxOrderSpend = getSpendLimit(maxTotalOrderSpendConfig);
  const translationsData = JSON.parse(translationsJSON);
  const modalMessage =
    translationsData.translations[
      "optimized_checkout.validation_messages.max_total_order_spend.modal_message"
    ] || "You cannot purchase more than [MAX_SPEND] in a single order";
  const modalHeading =
    translationsData.translations[
      "optimized_checkout.validation_messages.max_total_order_spend.modal_heading"
    ] || "Unable to checkout";

  showAlertModal(
    modalMessage.replace("[MAX_SPEND]", `${localiseCurrency(maxOrderSpend)}`),
    {
      icon: false,
      heading: modalHeading,
      confirmButtonAdditionalClass: "button--no-bottom-margin",
    }
  );
}

export function injectBlockerElement($container, clickEventHandler) {
  $container[0].style.position = "relative";

  const blockerElement = document.createElement("div");

  blockerElement.style.cssText =
    "display: block; position: absolute; top: 0; right: 0; bottom: 0; left: 0; pointer-events:all; z-index:1";
  blockerElement.setAttribute("data-additional-checkout-buttons-blocker", "");

  $(blockerElement).off("click").on("click", clickEventHandler);

  $container[0].append(blockerElement);
}

export function showStandaloneAlertModal({
  heading = "",
  message = "",
  confirmButtonHref = null,
  confirmButtonText = "Confirm",
  buttonTextColor = "#ffffff",
  buttonBackgroundColor = "#000000",
}) {
  // clear existing modal
  document
    .querySelectorAll(".modal-background")
    .forEach((modalBackground) => modalBackground.remove());
  document.querySelectorAll(".modal").forEach((modal) => modal.remove());

  fetch(window.standaloneModalHtmlUrl)
    .then((r) => r.text())
    .then((src) => {
      const modalHtml = src
        .replaceAll("{{heading}}", heading)
        .replaceAll("{{message}}", message)
        .replaceAll("{{confirmButtonHref}}", confirmButtonHref)
        .replaceAll("{{confirmButtonText}}", confirmButtonText)
        .replaceAll("{{buttonTextColor}}", buttonTextColor)
        .replaceAll("{{buttonBackgroundColor}}", buttonBackgroundColor);

      document.querySelector("body").insertAdjacentHTML("beforeend", modalHtml);
    });
}
